export const SPLASH_KEY = 'estage_splash_at';
const THROTTLE_MS = 60 * 60 * 1000;

export function shouldShowSplash(): boolean {
  try {
    const last = localStorage.getItem(SPLASH_KEY);
    if (!last) return true;
    return Date.now() - Number(last) > THROTTLE_MS;
  } catch {
    return false;
  }
}
